module.exports = __webpack_public_path__ + "img/Singapore-2-hover.720d403d.jpg";